// src/components/AdminPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/AdminPage.css';

// Seus componentes existentes
import ProductManagement from './ProductManagement';
import CouponManagement from './CouponManagement';
import ContentManagement from './ContentManagement';

function AdminPage() {
  const [activeTab, setActiveTab] = useState('products');
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Verificar autenticação ao carregar
  useEffect(() => {
    checkAuthentication();
  }, []);

  const checkAuthentication = () => {
    try {
      const token = localStorage.getItem('adminToken');
      const adminData = localStorage.getItem('adminData');

      if (!token || !adminData) {
        navigate('/admin/login');
        return;
      }

      const parsedAdmin = JSON.parse(adminData);

      // Verificar se é o supportAdmin
      if (parsedAdmin.username !== 'supportAdmin' || parsedAdmin.role !== 'superadmin') {
        alert('Acesso negado. Apenas administradores com privilégios podem acessar.');
        handleLogout();
        return;
      }

      setAdmin(parsedAdmin);
    } catch (error) {
      console.error('Erro ao verificar autenticação:', error);
      handleLogout();
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    if (window.confirm('Tem certeza que deseja sair?')) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminData');
      navigate('/admin/login');
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'products':
        return <ProductManagement />;
      case 'coupons':
        return <CouponManagement />;
      case 'content':
        return <ContentManagement />;
      default:
        return <ProductManagement />;
    }
  };

  // Loading state
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: '20px'
      }}>
        <div style={{
          width: '50px',
          height: '50px',
          border: '5px solid #f3f3f3',
          borderTop: '5px solid #FFD700',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <p style={{ color: '#666' }}>Verificando autenticação...</p>
      </div>
    );
  }

  return (
    <div className="admin-page-container">
      {/* Header com informações do admin */}
      <header className="admin-header">
        <div className="admin-header-left">
          <h1>🛠️ Painel Administrativo</h1>
          <span className="admin-subtitle">Gabrielly Semijoias</span>
        </div>
        <div className="admin-header-right">
          <div className="admin-user-info">
            <span className="admin-role">👑 Super Admin</span>
            <span className="admin-name">
              {admin?.username || 'supportAdmin'}
            </span>
          </div>
          <button onClick={handleLogout} className="logout-btn">
            🚪 Sair
          </button>
        </div>
      </header>

      {/* Navegação existente */}
      <div className="admin-nav">
        <button
          onClick={() => setActiveTab('products')}
          className={activeTab === 'products' ? 'active' : ''}
        >
          📦 Produtos
        </button>
        <button
          onClick={() => setActiveTab('coupons')}
          className={activeTab === 'coupons' ? 'active' : ''}
        >
          🎫 Cupons
        </button>
        <button
          onClick={() => setActiveTab('content')}
          className={activeTab === 'content' ? 'active' : ''}
        >
          📝 Conteúdo
        </button>
      </div>

      {/* Conteúdo */}
      <div className="admin-content">
        {renderContent()}
      </div>
    </div>
  );
}

export default AdminPage;